import auth0 from 'auth0-js'
import decode from 'jwt-decode'

export default class Authenticator {
  constructor () {
    this.auth0 = new auth0.WebAuth({
      domain: 'hosenrah.eu.auth0.com',
      clientID: 'wxpxlh07DJmSYUbXSn5X3Dm2Al7EONOM',
      // redirectUri: 'https://ray-yafi-portfolio.firebaseapp.com/auth',
      redirectUri: 'https://ryafi.com/auth',
      // redirectUri: 'http://localhost:8080/auth',
      // audience: 'https://hosenrah.eu.auth0.com/userinfo',
      responseType: 'token id_token',
      scope: 'openid profile email'
    })
    this.namespace = 'https://example.com'
  }

  login () {
    this.auth0.authorize()
  }

  getRole (idToken) {
    if (idToken) {
      return decode(idToken)[`${this.namespace}/role`] || null
    }
  }

  getEmail (idToken) {
    if (idToken) {
      return decode(idToken).email || null
    }
  }

  handleAuthentication () {
    return new Promise((resolve, reject) => {
      this.auth0.parseHash((err, authResult) => {
        if (err) return reject(err)

        resolve(authResult)
      })
    })
  }
}
